import { render, staticRenderFns } from "./FixEvent.vue?vue&type=template&id=6d51c5c4&scoped=true&"
import script from "./FixEvent.vue?vue&type=script&lang=js&"
export * from "./FixEvent.vue?vue&type=script&lang=js&"
import style0 from "./FixEvent.vue?vue&type=style&index=0&id=6d51c5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51c5c4",
  null
  
)

export default component.exports